import { render, staticRenderFns } from "./meal-order.vue?vue&type=template&id=29d6e996"
import script from "./meal-order.vue?vue&type=script&lang=js"
export * from "./meal-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports